/**
 * Styled components for WCCMultiBUOfferPriceBreakdown
 */

import styled from "styled-components";
import { Headline } from "root/libs/ui-components/src";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { DhlText } from "@dhl-official/react-library";

const lightBorder = `1px solid var(--dui-color-gray-200);`;
const innerBorder = `1px solid var(--dui-color-gray-500);`;

export const PriceBreakdownSegmentWrapper = styled.div`
  margin-bottom: 10px;
  border-top: ${lightBorder};
  padding: var(--gaq-size-space-15px) 0px var(--gaq-size-space-15px);

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: var(--gaq-size-space-15px) var(--gaq-size-space-15px);
  }
`;

export const PriceBreakdownHeadlineWrapper = styled.div`
  padding: 0px 0px var(--dui-size-space-5x);
  display: flex;
`;

export const PriceBreakdownWrapper = styled.div`
  display: flex;
  padding: var(--dui-size-space-5x) 0px;
  border-top: ${innerBorder};
  border-bottom: ${innerBorder};
`;

export const FullWidthTable = styled.table`
  width: ${(props) => (props.hasEuroPrice ? "100%" : "auto")};
`;

export const StyledHeadline = styled(Headline)`
  top: 10px;
  right: 10px;
  background-color: var(--dui-color-white-500);
  border: 1px solid var(--dui-color-red-500);
  color: var(--dui-color-red-500) !important;
  padding: var(--dui-size-space-2x) var(--dui-size-space-5x)
    var(--dui-size-space-2x);
  font-size: 1.5rem !important;
  line-height: normal !important;

  @media screen and (min-width: 1150px) {
    top: 0;
    right: 0;
  }
`;

export const StyledLabels = styled.th`
  text-align: left;
  padding: var(--gaq-size-space-5px) 0;
  width: ${(props) => (props.hasEuroPrice ? "85px" : "auto")};
`;

export const StyledValues = styled.td`
  padding: var(--gaq-size-space-5px) 0px var(--gaq-size-space-5px)
    var(--dui-size-space-5x);
  min-width: 180px;
`;

export const ExchangeRateCell = styled(StyledValues)`
  text-align: right;
`;

export const StyledLabelText = styled(DhlText)`
  &,
  & > *:is(p, span) {
    font-weight: 800 !important;
  }
`;

// We no longer need this component as we're handling width in StyledLabels
export const FixedWidthLabel = styled(StyledLabelText)``;

export const EuroPriceSpan = styled.span`
  display: inline-block;
  min-width: 120px;
  margin-left: 20px;
`;

export const PriceContainer = styled.span`
  display: inline-block;
  min-width: 100px;
`;
